<template>
    <div class="srv-tbl">
        <header class="srv-head">
            <button class="srv-icone-btn" aria-label="Retour" @click="$emit('fermer')">
                <i class="ri-arrow-left-line"></i>
            </button>
            <div>
                <div class="srv-head-titre">Choisir la table</div>
                <div class="srv-head-sous">{{ tables.length }} tables</div>
            </div>
        </header>

        <div class="srv-corps">
            <span class="srv-recherche">
                <i class="ri-search-line"></i>
                <input v-model="q" type="search" placeholder="Rechercher une table…" />
                <button v-if="q" class="srv-recherche-x" aria-label="Effacer" @click="q = ''">
                    <i class="ri-close-line"></i>
                </button>
            </span>

            <div v-if="!visibles.length" class="srv-vide">
                <i class="ri-search-line"></i>
                <p>Aucune table</p>
                <small>Essayez une autre recherche.</small>
            </div>

            <div class="srv-grille">
                <!-- Une table occupée reste sélectionnable : on ajoute souvent
                     des articles à une table déjà servie. -->
                <button v-for="t in visibles" :key="t.pid"
                        class="srv-case" :class="{ occupee: occupees[t.pid] }"
                        @click="$emit('choisir', t)">
                    <!-- Badge du nombre de commandes en cours : une table peut
                         porter plusieurs additions (plusieurs clients). -->
                    <span v-if="compteur[t.pid]" class="srv-case-badge srv-num">{{ compteur[t.pid] }}</span>
                    <span class="srv-case-nom">{{ t.name }}</span>
                    <span class="srv-case-etat">
                        <span class="srv-point"></span>
                        {{ compteur[t.pid]
                            ? compteur[t.pid] + ' commande' + (compteur[t.pid] > 1 ? 's' : '')
                            : 'Libre' }}
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import { sansAccent } from "../menu/format";

    export default {
        name: "srvchoixtable",
        props: {
            tables: { type: Array, default: () => [] },
            occupees: { type: Object, default: () => ({}) },
            // { [table.pid]: nombre de commandes en cours }
            compteur: { type: Object, default: () => ({}) },
        },
        emits: ["choisir", "fermer"],
        data: () => ({ q: "" }),
        computed: {
            visibles() {
                const q = sansAccent(this.q.trim());
                if (!q) return this.tables;
                return this.tables.filter(
                    (t) => sansAccent(t.name + " " + (t.code || "")).indexOf(q) !== -1
                );
            },
        },
    };
</script>

<style scoped>
    .srv-tbl { display: flex; flex-direction: column; min-height: 100vh; }

    .srv-recherche {
        display: flex; align-items: center; gap: 10px;
        min-height: var(--srv-tap); padding: 0 14px; margin-bottom: var(--srv-md);
        background: var(--srv-surface);
        border: 1px solid var(--srv-border-fort); border-radius: var(--srv-r-input);
    }
    .srv-recherche i { font-size: 20px; color: var(--srv-outline); }
    .srv-recherche input {
        flex: 1; min-width: 0; background: none; border: none; outline: none;
        color: var(--srv-on); font-family: inherit; font-size: 16px;
    }
    .srv-recherche input::placeholder { color: var(--srv-outline); }
    .srv-recherche-x { background: none; border: none; color: var(--srv-outline); cursor: pointer; padding: 4px; }

    .srv-grille { display: grid; grid-template-columns: repeat(2, 1fr); gap: var(--srv-sm); }
    @media (min-width: 400px) { .srv-grille { grid-template-columns: repeat(3, 1fr); } }

    .srv-case {
        position: relative;
        display: flex; flex-direction: column; align-items: flex-start; justify-content: center; gap: 6px;
        min-height: 76px; padding: 12px;
        background: var(--srv-surface); color: var(--srv-on);
        border: 1px solid var(--srv-outline-variant); border-radius: var(--srv-r);
        font-family: inherit; cursor: pointer; text-align: left;
    }
    .srv-case-badge {
        position: absolute; top: 8px; right: 8px;
        min-width: 22px; height: 22px; padding: 0 6px;
        display: inline-flex; align-items: center; justify-content: center;
        background: var(--srv-primary); color: var(--srv-on-primary);
        border-radius: var(--srv-r-chip); font-size: 12px; font-weight: 800;
    }
    .srv-case:hover { border-color: var(--srv-primary); }
    .srv-case-nom { font-size: 15px; font-weight: 700; }
    .srv-case-etat {
        display: flex; align-items: center; gap: 6px;
        font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em;
        color: var(--srv-success);
    }
    .srv-point { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }

    .srv-case.occupee { border-color: var(--srv-warn); background: var(--srv-warn-soft); }
    .srv-case.occupee .srv-case-etat { color: var(--srv-warn-on); }
</style>
